import React, { useEffect, useState } from 'react';
import { Table, Button, Popconfirm, Space, Row, Col, Input, DatePicker, Select, Tabs, Calendar, Badge } from 'antd';
import type { Dayjs } from 'dayjs';
import AppLayout from '../../components/AppLayout';

const ShiftAndAttendance: React.FC = () => {
  const [records, setRecords] = useState<any[]>([]);
  const [filters, setFilters] = useState({ employee: '', date: null, shift: '' });
  const [filteredRecords, setFilteredRecords] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState('table');

  useEffect(() => {
    const demoData = Array.from({ length: 50 }, (_, i) => ({
      id: i + 1,
      employee_name: `Employee ${i + 1}`,
      date: `2024-07-${(i % 28 + 1).toString().padStart(2, '0')}`,
      shift_type: ['Morning', 'Evening', 'Night'][i % 3],
      check_in: '09:00 AM',
      check_out: '05:00 PM',
      total_hours: '8h',
      status: ['Present', 'Absent', 'Late'][i % 3],
    }));
    setRecords(demoData);
    setFilteredRecords(demoData);
  }, []);

  const handleFilterChange = (field: string, value: any) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);

    const filtered = records.filter(r =>
      (newFilters.employee === '' || r.employee_name.toLowerCase().includes(newFilters.employee.toLowerCase())) &&
    //   (newFilters.date === null || r.date === newFilters.date?.format('YYYY-MM-DD')) &&
      (newFilters.shift === '' || r.shift_type === newFilters.shift)
    );
    setFilteredRecords(filtered);
  };

  const columns = [
    { title: 'Employee Name', dataIndex: 'employee_name', key: 'employee_name' },
    { title: 'Date', dataIndex: 'date', key: 'date' },
    { title: 'Shift Type', dataIndex: 'shift_type', key: 'shift_type' },
    { title: 'Check-In', dataIndex: 'check_in', key: 'check_in' },
    { title: 'Check-Out', dataIndex: 'check_out', key: 'check_out' },
    { title: 'Total Hours', dataIndex: 'total_hours', key: 'total_hours' },
    { title: 'Status', dataIndex: 'status', key: 'status' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: any) => (
        <Space>
          <Button type="link">Edit</Button>
          <Button type="link" onClick={() => console.log('Mark Present', record.id)}>Mark Present</Button>
          <Popconfirm title="Are you sure to delete?" onConfirm={() => console.log('Delete', record.id)}>
            <Button danger type="link">Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const getListData = (value: Dayjs) => {
    const dateStr = value.format('YYYY-MM-DD');
    return filteredRecords
      .filter(r => r.date === dateStr)
      .map(r => ({
        type: r.status === 'Present' ? 'success' : r.status === 'Late' ? 'warning' : 'error',
        content: `${r.employee_name} (${r.status})`
      }));
  };

  const dateCellRender = (value: Dayjs) => {
    const listData = getListData(value);
    return (
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {listData.map((item, index) => (
          <li key={index}>
            <Badge status={item.type as any} text={item.content} />
          </li>
        ))}
      </ul>
    );
  };

  return (
    <AppLayout>
      <Tabs activeKey={activeTab} onChange={setActiveTab}>
        <Tabs.TabPane tab="Table View" key="table">
          <Row gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8}>
              <Input
                placeholder="Search Employee"
                value={filters.employee}
                onChange={(e) => handleFilterChange('employee', e.target.value)}
              />
            </Col>
            <Col span={8}>
              <DatePicker
                placeholder="Select Date"
                onChange={(date) => handleFilterChange('date', date)}
                style={{ width: '100%' }}
              />
            </Col>
            <Col span={8}>
              <Select
                placeholder="Select Shift"
                value={filters.shift}
                onChange={(val) => handleFilterChange('shift', val)}
                allowClear
                style={{ width: '100%' }}
              >
                <Select.Option value="Morning">Morning</Select.Option>
                <Select.Option value="Evening">Evening</Select.Option>
                <Select.Option value="Night">Night</Select.Option>
              </Select>
            </Col>
          </Row>
          <Table
            dataSource={filteredRecords}
            columns={columns}
            rowKey="id"
            pagination={{ pageSize: 10 }}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Calendar View" key="calendar">
          <Calendar dateCellRender={dateCellRender} />
        </Tabs.TabPane>
      </Tabs>
    </AppLayout>
  );
};

export default ShiftAndAttendance;
